import { css } from 'aphrodite';
import { useState } from 'react';
import { Button } from '../../../components-v2/Button';
import { Modal } from '../../../components/Modal';
import { RadioButton } from '../../../components/RadioButton';
import { styleSheet } from './styles';

type Props = {
	isOpen: boolean;
	onClose: (showAiGeneratedContent: boolean, cancel?: boolean) => void;
};

export const AiGeneratedContentSelectionModal = ({ isOpen, onClose }: Props) => {
	const [showAiGeneratedContent, setShowAiGeneratedContent] = useState(true);

	return (
		<Modal isOpen={isOpen}>
			<div className={css(styleSheet.container)}>
				<h1 className={css(styleSheet.title)}>Choose how you&apos;d like to see recommendations</h1>

				<div className={css(styleSheet.toggleButtonsContainer)}>
					<RadioButton
						checked={!showAiGeneratedContent}
						id='show-ghost-calendar'
						onChange={() => setShowAiGeneratedContent(false)}
						className={css(styleSheet.toggleButton)}
					>
						<span>
							<strong>Ghost Calendar</strong> Classic content suggestions made by our content team, aligned to the
							client&apos;s subverticals
						</span>
					</RadioButton>

					<RadioButton
						checked={showAiGeneratedContent}
						id='show-ai-generated-content'
						onChange={() => setShowAiGeneratedContent(true)}
						className={css(styleSheet.toggleButton)}
					>
						<span>
							<strong>AI Calendar</strong> <span className={css(styleSheet.recommendedText)}>(recommended)</span>: Let
							Levitate&apos;s AI write tailored, unique content base on the Ghost Calendar in addition to specific
							account info - past sends, location, content preferences
						</span>
					</RadioButton>
				</div>

				<div className={css(styleSheet.buttonsContainer)}>
					<Button onClick={() => onClose(showAiGeneratedContent)}>Go to Calendar</Button>
					<Button variant='secondary' onClick={() => onClose(showAiGeneratedContent, true)}>
						Cancel
					</Button>
				</div>
			</div>
		</Modal>
	);
};
